(function () {
  'use strict';

  function formatMoney(cents) {
    if (typeof window.vskloFormatMoney === 'function') {
      return window.vskloFormatMoney(cents);
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var settings = window.themeGlobalVariables && window.themeGlobalVariables.settings;
      return window.Shopify.formatMoney(cents, settings && settings.money_format);
    }
    var amount = Number(cents || 0) / 100;
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    if (currency && window.Intl && Intl.NumberFormat) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: currency
        }).format(amount);
      } catch (error) {}
    }
    return amount.toLocaleString(document.documentElement.lang || undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function init(bar) {
    if (!bar || bar.dataset.vpsReady === 'true') return;
    var threshold = Number(bar.dataset.showAfter || 0);
    var input = bar.querySelector('[data-vps-sticky-variant]');
    var price = bar.querySelector('[data-vps-sticky-price]');
    var button = bar.querySelector('[data-vps-sticky-button]');
    var label = bar.querySelector('[data-vps-sticky-label]');
    var availableLabel = button && (button.dataset.availableLabel || button.textContent.trim()) || '';
    var soldOutLabel = button && button.dataset.soldOutLabel || '';
    var marketUnavailable = Boolean(button && button.dataset.vskloMarketUnavailable === 'true');
    var marketUnavailableLabel = button && button.dataset.marketUnavailableLabel || soldOutLabel;
    var image = bar.querySelector('.vps-sticky__image');
    var variants = [];
    try { variants = JSON.parse(bar.querySelector('[data-vps-sticky-variants]').textContent || '[]'); } catch (error) {}

    function visibility() { bar.classList.toggle('is-visible', window.scrollY >= threshold); }
    function update(variant) {
      if (!variant) return;
      if (input) input.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price);
      if (button) {
        var purchaseDisabled = marketUnavailable || !variant.available;
        button.disabled = purchaseDisabled;
        button.setAttribute('aria-disabled', purchaseDisabled ? 'true' : 'false');
      }
      if (label) {
        label.textContent = marketUnavailable
          ? marketUnavailableLabel
          : (variant.available ? availableLabel : soldOutLabel);
      }
      if (image && variant.featured_image && variant.featured_image.src) image.src = variant.featured_image.src;
    }
    function onVariantChange(event) {
      update(event.detail && event.detail.variant);
    }

    function onVariantInputChange(event) {
      if (!event.target.matches('form[action*="/cart/add"] [name="id"]')) return;
      var variant = variants.find(function (item) { return String(item.id) === String(event.target.value); });
      if (variant) update(variant);
    }

    document.addEventListener('vsklo:variant:change', onVariantChange);
    document.addEventListener('change', onVariantInputChange);
    window.addEventListener('scroll', visibility, { passive: true });

    bar.__vskloStickyCleanup = function () {
      document.removeEventListener('vsklo:variant:change', onVariantChange);
      document.removeEventListener('change', onVariantInputChange);
      window.removeEventListener('scroll', visibility);
      bar.__vskloStickyCleanup = null;
      delete bar.dataset.vpsReady;
    };

    visibility();
    bar.dataset.vpsReady = 'true';
  }

  function syncStandalone(variant) {
    if (!variant) return;
    document.querySelectorAll('[data-vps-sync-variant]').forEach(function (input) { input.value = variant.id; });
    document.querySelectorAll('[data-vps-sync-button]').forEach(function (button) {
      var marketUnavailable = button.dataset.vskloMarketUnavailable === 'true';
      var purchaseDisabled = marketUnavailable || !variant.available;
      button.disabled = purchaseDisabled;
      button.setAttribute('aria-disabled', purchaseDisabled ? 'true' : 'false');
      var label = button.querySelector('[data-vps-sync-label]');
      if (label) {
        label.textContent = marketUnavailable
          ? (button.dataset.marketUnavailableLabel || label.textContent)
          : (variant.available ? button.dataset.availableLabel : button.dataset.soldOutLabel);
      }
    });
    if (variant.featured_image && variant.featured_image.src) {
      document.querySelectorAll('[data-vps-sync-image] img').forEach(function (image) {
        image.src = variant.featured_image.src;
        image.removeAttribute('srcset');
      });
    }
  }

  function boot(root) { (root || document).querySelectorAll('[data-vps-sticky]').forEach(init); }
  document.addEventListener('vsklo:variant:change', function (event) { syncStandalone(event.detail && event.detail.variant); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }); else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    (event.target || document).querySelectorAll('[data-vps-sticky]').forEach(function (bar) {
      if (typeof bar.__vskloStickyCleanup === 'function') bar.__vskloStickyCleanup();
    });
  });
})();
